import React from "react";
import {
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";


function PartnerSect() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
    >
        <Box
              sx={{
                padding: "90px",
                width: "100%",
                height: "auto", // Make height flexible
                
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: isMobile ? "center" : "start",
                // paddingX: isMobile ? "20px" : "85px", // Adjust padding based on screen size
                pl: { xs: 2, sm: 3, md: "84px" },
                pr: { xs: 2, sm: 2.5, md: "115px" },
              }}
            >
              <Grid
                container
                spacing={3}
                sx={{
                  maxWidth: "xl", // Restrict max width for better responsiveness
                  marginX: { xs: "20px", sm: "50px", md: "100px", lg: "140px" },
                  alignItems: "flex-start",
                
                }}
              >
                {/* Text Section */}
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { xs: "32px", sm:'42px', md: "42px" },
                      fontWeight: 400,
                      marginBottom: "24px",
                      color: "#333",
                      
                    }}
                  >
                    Our Strategic Alliances & Industry Footprint
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: { xs: "16px",m:'18px', md: "18px" },
                      color:'#000000DE',
                      lineHeight: 1.6,
                      
                      fontWeight: 300,
                    }}
                  >
              At Devangles, our strength is amplified through powerful collaborations and active participation in the industry’s leading organizations.
              </Typography>
                </Grid>
      
                {/* Button Section */}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: isMobile ? "20px" : 0, // Add spacing on small screens
                  }}
                >
                  <Box
                    component="img"
                    src="/businessmen-closing-deal-with-handshake_1098-3793.avif"
              alt="A team collaborating at a table, using laptops to develop solutions for innovation and growth"
                    sx={{
                      width: "100%", // Makes the image responsive
      
                      height: "auto", // Maintains aspect ratio
                      borderRadius: "15px", // Optional: Adds rounded corners
                      justifyContent: "end",
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
      
      
    </Box>
  );
}

export default PartnerSect;